import { getQueryStringValueTyped } from "./url";

const getDefaultMapZoom = (): number => {
  const zoom = getQueryStringValueTyped("map_zoom_level", Number);
  return zoom ? zoom : VisitWidget.settings.currentClientMapZoomLevel;
};

export { getDefaultMapZoom };
